/**
 * Display thresholds for the recommendations UI.
 *
 * Centralized so the visible cap, emphasized top-N ("strong") count, and weight
 * cutoff are tunable in one place instead of being hardcoded inside components.
 * Applies to both the supplement and lifestyle lists.
 *
 *   maxVisible   - maximum rows/cards rendered
 *   strong       - the top-N entries that get the emphasized "strong" treatment
 *   weightCutoff - entries with a weight below this are hidden (0 = show all)
 *
 * Supplements rank on `total_weight`; lifestyle ranks on the summed `weight`
 * (score) produced by the backend. The lists arrive pre-sorted from the engine.
 *
 * The `protocol` section additionally drives the category-band cut used when
 * building the editable protocol's generated groups (useProtocolEditor):
 *
 *   hardFloorRatio   - groups below maxWeight * hardFloorRatio are always dropped
 *   softCeilingRatio - groups at/above maxWeight * softCeilingRatio always survive
 *   topN             - the first `topN` groups (by weight) survive regardless of
 *                      the soft ceiling, so a minimum set is always shown
 *
 * The current values reproduce the previous hardcoded behavior exactly; tune
 * here to change how many generated categories surface without touching code.
 */
export const RECOMMENDATION_DISPLAY = {
    supplements: {
        maxVisible: 8,
        strong: 3,
        weightCutoff: 0,
    },
    lifestyle: {
        maxVisible: 6,
        strong: 3,
        weightCutoff: 0.15,
    },
    protocol: {
        maxVisible: 8,
        strong: 3,
        weightCutoff: 0,
        hardFloorRatio: 0.30,
        softCeilingRatio: 0.50,
        topN: 3,
    },
};

export default RECOMMENDATION_DISPLAY;
